import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/CreateAdmin.css";

function CreateAdmin() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    employeeCode: "",
    organizationName: "",
    organizationAddress: "",
    organizationContact: "",
    gender: "", // Added gender field
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No authentication token found");
        return;
      }
      const response = await axios.post(
        'https://api.uniums.com/api/auth/create-admin',
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      toast.success("Admin created successfully!");

      // Reset form data
      setFormData({
        name: "",
        email: "",
        password: "",
        employeeCode: "",
        organizationName: "",
        organizationAddress: "",
        organizationContact: "",
        gender: "", // Reset gender field
        role: "admin",
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create admin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-admin">
      <h1 className="create-admin-title">Create New Admin</h1>
      <form className="create-admin-form" onSubmit={handleSubmit}>
        {/* Admin Details */}
        <h2 className="form-section-title">Admin Details</h2>
        <div className="form-row">
          <div className="form-group-inline">
            <label htmlFor="name">Admin Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group-inline">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group-inline">
            <label htmlFor="gender">Gender</label>
            <select
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
              <option value="prefer_not_to_say">Prefer not to say</option>
            </select>
          </div>
          <div className="form-group-inline">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group-inline">
            <label htmlFor="employeeCode">Employee Code</label>
            <input
              type="text"
              id="employeeCode"
              name="employeeCode"
              value={formData.employeeCode}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Organization Details */}
        <h2 className="form-section-title">Organization Details</h2>
        <div className="form-row">
          <div className="form-group-inline">
            <label htmlFor="organizationName">Organization Name</label>
            <input
              type="text"
              id="organizationName"
              name="organizationName"
              value={formData.organizationName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group-inline">
            <label htmlFor="organizationContact">Organization Contact</label>
            <input
              type="tel"
              id="organizationContact"
              name="organizationContact"
              value={formData.organizationContact}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group-inline">
            <label htmlFor="organizationAddress">Organization Address</label>
            <input
              type="text"
              id="organizationAddress"
              name="organizationAddress"
              value={formData.organizationAddress}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? "Creating..." : "Create Admin"}
        </button>
      </form>
      <ToastContainer />
    </div>
  );
}

export default CreateAdmin;